import React from "react";
import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import StandardLabel from "./StandardLabel";
import { Link } from "react-router-dom";

const LabeledEntry = ({
  label,
  value,
  placeholder,
  link,
  isExternalLink = false,
}) => {

  const LinkWrapper = ({ children }) => {
    return !link
      ? <>{children}</>
      : isExternalLink ? (
        <Box
          component="a"
          href={`//${link}`}
          target="_blank"
        >
          <MuiLink component="span">
            {children}
          </MuiLink>
        </Box>
      ) : (
        <Link to={link}>
          <MuiLink component="span">
            {children}
          </MuiLink>
        </Link>
      );
  };

  return (
    <Stack>
      {label && <StandardLabel labelText={label}/>}
      <LinkWrapper>
        {value?.toString().trim().length ? (
          <Typography
            component="p"
            variant="body1"
            sx={{ whiteSpace: "break-spaces" }}
          >
            {value.toString()}
          </Typography>
        ) : (
          <Typography
            component="p"
            color="text.disabled"
            variant="body1"
            sx={{ userSelect: "none" }}
          >
            {placeholder}&nbsp;
          </Typography>
        )}
      </LinkWrapper>
    </Stack>);
};

export default LabeledEntry;